import { isCheckBasicCampaignDiscountActive } from 'core/service/basic-plan/basic-plan'
import _ from 'lodash'
import { call, put, select, takeLatest } from 'redux-saga/effects'

import { SELECT_PRODUCT_LIFE_PROTECT_PLUS, SELECTED_BOOSTER_PLAN } from './actions'

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* watchers(serviceWrapper) {
  const { LIFE_PROTECT_PLUS } = serviceWrapper.products

  yield [takeLatest([SELECT_PRODUCT_LIFE_PROTECT_PLUS], LIFE_PROTECT_PLUS.onUpdateSwitchPlanLifeProtectPlus)]
  yield [takeLatest([SELECTED_BOOSTER_PLAN], LIFE_PROTECT_PLUS.onUpdateSelectedBoosterPlan)]
}

export const sagas = watchers
